import PropTypes from 'prop-types';
import { UserInteractions } from '../../../shared/enums';


const mePropTypes = PropTypes.shape({
  _id: PropTypes.string,
  role: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  primaryLanguage: PropTypes.string,
  interactions: PropTypes.shape({
    [UserInteractions.isOnboardingPassed]: PropTypes.bool,
    [UserInteractions.SeenChatbot]: PropTypes.bool,
  }),
  project: PropTypes.shape({
    isProjectTimelineShown: PropTypes.bool,
    isProjectAccessBlocked: PropTypes.bool,
  }),
});

export default mePropTypes;
